import { useEffect, useRef } from "react";
import { lockBodyScroll } from "./bodyScrollLock";

const dialogs = [];

export default function useDialogFocus(open, onClose) {
  const ref = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.activeElement;
    const dialog = ref.current;
    const unlock = lockBodyScroll();
    dialogs.push(dialog);
    const focusable = () => Array.from(dialog?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]') || []).filter((element) => element.getClientRects().length);
    (focusable()[0] || dialog)?.focus({ preventScroll: true });
    const onKey = (event) => {
      if (dialogs[dialogs.length - 1] !== dialog) return;
      if (event.key === "Escape") { event.preventDefault(); close.current(); }
      if (event.key !== "Tab") return;
      const elements = focusable();
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) { event.preventDefault(); dialog?.focus(); return; }
      if (!dialog?.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      const index = dialogs.indexOf(dialog);
      if (index !== -1) dialogs.splice(index, 1);
      unlock();
      if (previous?.isConnected && typeof previous.focus === "function") previous.focus({ preventScroll: true });
    };
  }, [open]);
  return ref;
}
